import _ from 'lodash'

import md5 from 'md5'

export default function tryLogin(searchPerson) {

    return function (schema, login, password) {

        return new Promise((resolve, reject) => {
            searchPerson({login: schema + '.' + formatLogin(login)})
                .then((person) => {
                    if (md5(password) === _.get(person, 'password', 0))
                        return resolve({success: true, person})

                    resolve({success: false})

                })
                .catch(error => reject({success: false, error}))
        })
    }

}


export const formatLogin = login => {
    const pattern = /\d+/

    if (pattern.test(login)) {
        if (login.length == 11) {
            return login.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
        } else {
            return login.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
        }
    }

    return login
}



// WEBPACK FOOTER //
// ./src/_functions/try-login.js